export default "__VITE_ASSET__B_GI5Vvj__"